import { createFileRoute, redirect } from "@tanstack/react-router";
import { entriesSearchSchema } from "../../components/entries/entries-page";
import { entriesView } from "../../lib/entries/access";

/**
 * `/accreditation/entries`. The admins' Entries dashboard is Sector 1's
 * Dashboard now (`/dashboard/entries`, user 2026-10-31), so they go there
 * with their filters; anyone else goes on to the first step, Expression of
 * interest, as before.
 */
export const Route = createFileRoute("/_app/accreditation/entries/")({
	validateSearch: entriesSearchSchema,
	beforeLoad: ({ context, search }) => {
		if (entriesView(context.session) === "admin") throw redirect({ to: "/dashboard/entries", search, replace: true });
		throw redirect({ to: "/accreditation/entries/eoi", replace: true });
	},
});
